import React, { useEffect, useState } from "react";
import { Table } from 'react-bootstrap';
import { Loading, UserDetail, Pagination } from "../../../../../common";

import { format } from 'date-fns';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { url } from "../../../../../config";
const axios = require("axios").default;

export default function CompetitionsTable({ month }) {
    const [data, setData] = useState({ page: 0, totalPage: 0, totalElements: 0, data: [] });
    const [loading, setLoading] = useState(true);
    const [userDetailId, setUserDetailId] = useState(null);

    useEffect(() => {
        loadData(0);
    }, [])

    const loadData = (page) => {
        //za zvolene obdobie
        //let baseUrl = `/private/rest/kuzelnik/top-between-dates/{from}/{to}/{groupId} - from/to treba poslat ako timestamp

        //za zvoleny mesiac
        let baseUrl = `/private/rest/kuzelnik/monthly-top${month ? `/${month}` : ''}`

        axios.get(url + baseUrl + "?page=" + page + "&size=10")
            .then(res => {
                setData(res.data);
                setLoading(false);
            })
            .catch(err => { });
    }

    return (
        <>
            <Table>
                <thead>
                    <tr className="align-middle">
                        <th className="col-1"></th>
                        <th className="col-4">Kužeľník</th>
                        <th className="col-4">Počet udalostí</th>
                        <th className="col-5">Posledná udalosť</th>
                        <th className="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ? (
                            <tr className="text-center">
                                <td colSpan="100%" className="border-0">
                                    <Loading marginTop='170px'></Loading>
                                </td>
                            </tr>
                        ) : (
                            data.data.length ? (
                                data.data.map((user, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1 + data.page * 10}.</td>
                                            <td>{user.nickname}</td>
                                            <td>{user.count}</td>
                                            <td>{format(new Date(user.date), 'dd.MM.yyyy')}</td>
                                            <td>
                                                <FontAwesomeIcon onClick={() => setUserDetailId(user.id)} size="lg" className="me-1" icon="fa-regular fa-user" />
                                                {
                                                    userDetailId === user.id && (
                                                        <UserDetail user={user} onHideModal={() => setUserDetailId(null)} ></UserDetail>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr className="text-center">
                                    <td colSpan="100%" className="border-0">
                                        Zatiaľ nie sú nahlásené žiadne kužeľové udalosti za dané obdobie...
                                    </td>
                                </tr>
                            )
                        )
                    }
                </tbody>
            </Table>
            <div className="d-flex justify-content-center">
                <Pagination page={data.page} totalPages={data.totalPage} onPageChange={page => loadData(page)} />
            </div>
        </>
    );
}